import { IBudget } from "../../../../models/budgetV2";
import { createEmptyBudgetVersionService } from "../../budgetEdit/utils/emptyBudgetVersionService";

export const createEmptyBudget = (): IBudget => ({
  uuid: "",
  subscriptionBalanceApplied: 0,
  versionData: {
    services: [createEmptyBudgetVersionService()],
    proposalServices: [],
    subtotal: 0,
    discount: 0,
    netTotal: 0,
    observation: "",
  },
});
